import BaseAPI from "../api";

const path: string = "/advisor-form";

export type listType = {
  degree?: string;
  faculty?: string;
  date_of_issue?: string;
  year_graduated?: string;
  status?: string;
  created_id?: string;
  created_date?: string;
  modified_id?: string;
  modified_date?: number;
  type?: string;
  limit?: number;
  page?: number;
  keyword?: string;
  search?: string;
};

export class advisorFormApi extends BaseAPI {
  static getAllAdvisorForm(query?: listType): Promise<any> {
    return this.api.get(`${path}`, {
      params: { ...query },
    });
  }

  static getAdvisorFormById(id: number, token?: string): Promise<any> {
    if (!token) {
      return this.api.get(`${path}/${id}`);
    } else {
      return this.api.get(`${path}/${id}`, {
        headers: { Authorization: `Bearer ${token}` },
      });
    }
  }

  static createAdvisorForm(body: any): Promise<any> {
    return this.api.post(`${path}`, body);
  }

  static updateAdvisorForm(id: number, body: any): Promise<any> {
    return this.api.patch(`${path}/${id}`, body);
  }
  static updateAdvisorFormStatus(id: number, status: any): Promise<any> {
    return this.api.patch(`${path}/status`, {
      id_advisor_form: id,
      status: status,
    });
  }

  static deleteAdvisorForm(id: number): Promise<any> {
    return this.api.delete(`${path}/${id}`);
  }
}
